import React, { useState } from "react";
import styles from "./PersonalInfo.module.scss";
import artistImage from "../../../assets/images/artist-image.jpg";
import FollowIcon from "components/svgs/FollowIcon";
import SupportIcon from "components/svgs/SupportIcon";
import Biography from "../biography/Biography";
import CV from "../cv/CV";
import InstagramIcon from "components/svgs/InstagramIcon";
import WebsiteIcon from "components/svgs/WebsiteIcon";

const PersonalInfo = () => {
  const [following, setFollowing] = useState(false);

  const scrollToSection = (selector) => {
    const element = document.querySelector(selector);
    if (!element) return;
    const y = element.getBoundingClientRect().top + window.scrollY;
    const headerHeight = document.querySelector("header")?.offsetHeight || 100;
    window.scroll({
      top: y - headerHeight,
      behavior: "smooth",
    });
  };

  const handleMenuItemClick = (item) => {
    const sectionMap = {
      biography: ".biographyRef",
      cv: ".cvRef",
      paintings: ".paintingsRef",
      media: ".mediaRef",
      studio: ".studioRef",
    };

    const selector = sectionMap[item];
    if (selector) {
      scrollToSection(selector);
    }
  };

  return (
    <div className={styles.personalInfo}>
      <div className={styles.stickySidebarContainer}>
        <div className={`stickySidebar ${styles.stickySidebar}`}>
          <div className={styles.artistImage}>
            <img src={artistImage} alt="NAME LASTNAME" />
          </div>
          <ul className={styles.navigation}>
            <li onClick={() => handleMenuItemClick("biography")}>Biography</li>
            <li onClick={() => handleMenuItemClick("cv")}>CV</li>
            <li onClick={() => handleMenuItemClick("paintings")}>Paintings</li>
            <li onClick={() => handleMenuItemClick("media")}>Media</li>
            <li onClick={() => handleMenuItemClick("studio")}>Studio</li>
            <li
              className={styles.social}
              onClick={() => window.open("https://www.instagram.com")}
            >
              <InstagramIcon />
              https://www.instagram.com
            </li>
            <li
              className={styles.social}
              onClick={() => window.open("https://www.panarmenianarthub.com/")}
            >
              <WebsiteIcon />
              https://www.panarmenianarthub.com/
            </li>
            <li
              className={`${styles.follow} ${
                following ? styles.following : ""
              }`}
              onClick={(e) => {
                e.stopPropagation();
                setFollowing(!following);
              }}
            >
              <span>{!following ? "Follow The Artist" : "Following"}</span>
              {!following ? <FollowIcon /> : null}
            </li>
            <li
              className={`${styles.follow}`}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <span>Support The Artist</span>
              <SupportIcon />
            </li>
          </ul>
        </div>
      </div>
      <div className={styles.scrollableContent}>
        <Biography />
        <CV />
      </div>
    </div>
  );
};

export default PersonalInfo;
